import { FormControl, FormHelperText, TextField } from "@mui/material";
import { useMemo, type FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { ValidationHelpers, type ICustomField } from "@ryde/shared";

import { FullWidthTextFieldWrapper } from "../parts-styled";
import { FieldExplanationIcon } from "./_parts";

export const UrlTemplate: FC<ICustomField> = ({
  id,
  name,
  formLabel,
  formAttributes,
  formValidation,
  e2eData,
}) => {
  const { control } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });

  const requiredComputed = useMemo(() => {
    return ValidationHelpers.hasRequiredRule(formValidation);
  }, [formValidation]);

  return (
    <FullWidthTextFieldWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, ...fieldRest }, fieldState: { error } }) => (
          <FormControl
            required={requiredComputed}
            data-e2e-template="url-template"
            data-e2e-field-name={name}
            error={!!error}
          >
            <TextField
              {...fieldRest}
              data-e2e={e2eData}
              data-e2e-id={`${name}_${id || ""}`}
              label={formLabelTranslated}
              required={requiredComputed}
              error={!!error}
              fullWidth
              type="url"
              value={value || ""}
            />
            {error && (
              <FormHelperText>{error.message as string}</FormHelperText>
            )}
          </FormControl>
        )}
      />
      <FieldExplanationIcon formAttributes={formAttributes} />
    </FullWidthTextFieldWrapper>
  );
};
